import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useResource, useStore, useToast, usePage } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SF_EXRT_MGMT_SRCH,
    SG_EXRT_MGMT_LIST,
} from "@/tra/tancis/ptli/crtr/exrt/services/PtliExrtMgmtService";

/*
 * Exchage Rate Management List
 * !== 휴일 관리 목록 ==!
 */
export const PTLI0405001Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "COM0004" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0052", "auth_ptli0003", "auth_ptli0044"],
    });

    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();

    const form = {
        exrtMgmtSrch: useForm({
            defaultSchema: SF_EXRT_MGMT_SRCH,
            defaultValues: {
                ...pgeStore?.form,
                ctraExrtMdfyDtStrt: comnUtils.getDate({ m: -1 }),
                ctraExrtMdfyDtEnd: comnUtils.getDate(),
            },
        }),
    };

    const grid = {
        exrtMgmtList: useGrid({
            defaultSchema: SG_EXRT_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Retrieve a list of Exchange Rate Managements. !== 환율관리 목록을 조회한다.==!
        getExrtMgmtList: useFetch({
            api: (page = grid.exrtMgmtList.page) =>
                APIS.getExrtMgmtList(form.exrtMgmtSrch.getValues(), page, grid.exrtMgmtList.size),
            enabled: comnUtils.isEmpty(form.exrtMgmtSrch.errors),
            key: [grid.exrtMgmtList.page, grid.exrtMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.exrtMgmtSrch.getValues(),
                    page: grid.exrtMgmtList.page,
                    size: grid.exrtMgmtList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        getExrtMgmtList: () => {
            grid.exrtMgmtList.setPage(0);
            fetch.getExrtMgmtList.fetch(0);
        },
    };

    useEffect(() => {
        handler.getExrtMgmtList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.exrtMgmtSrch.schema.ctraExrtMdfyDt} />
                            <Group.Control {...form.exrtMgmtSrch.schema.currCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.exrtMgmtSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getExrtMgmtList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.exrtMgmtList.grid} data={fetch.getExrtMgmtList.data?.exrtMgmtList} />
                    </Group.Section>
                </Group.Body>
            </Group>

            {/* <Layout.Left>
                <Button
                    role="tmplDown"
                    onClick={() => {
                        comnUtils.downloadTemplate("1b48dc8d-5f00-d5df-e063-020011aceb63");
                    }}
                ></Button>
                <Button
                    role="excelUpload"
                    onClick={async () => {
                        const result = await comnUtils.importExcel({
                            url: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/crtr/exrt-mgmt/excel-upload`,
                        });

                        modal.openModal({
                            content: "msg.com.00058",
                            onCancel: () => {
                                handler.getExrtMgmtList();
                            },
                        });
                    }}
                ></Button>
            </Layout.Left> */}
        </Page>
    );
};
